var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCostServiceConfIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "costServiceConfIcon_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u9577\\u65B9\\u5F62 282",
    transform: "translate(543 46)",
    fill: "#a1a1a1",
    stroke: "#707070",
    d: "M0 0h36v36H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "costServiceConfIcon_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u9577\\u65B9\\u5F62 381",
    fill: "none",
    d: "M0 0h36v36H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "ServiceIcon",
    transform: "translate(-543 -46)",
    clipPath: "url(#costServiceConfIcon_svg__a)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "ServiceIcon",
    transform: "translate(543 46)",
    clipPath: "url(#costServiceConfIcon_svg__b)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 379",
    fill: "#040000"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u30D1\\u30B9 525",
    d: "M16.885 31.447a13.79 13.79 0 1113.79-13.79.75.75 0 01-1.5 0 12.29 12.29 0 10-12.29 12.29.75.75 0 010 1.5"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u30D1\\u30B9 526",
    d: "M16.885 19.179a1.522 1.522 0 111.522-1.522 1.522 1.522 0 01-1.522 1.522m0-2.2a.675.675 0 10.675.675.675.675 0 00-.675-.675"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u30D1\\u30B9 527",
    d: "M16.885 7.934a.75.75 0 01-.75-.75V4.662a.75.75 0 011.5 0v2.522a.75.75 0 01-.75.75"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u30D1\\u30B9 528",
    d: "M6.565 18.407H4.043a.75.75 0 110-1.5h2.522a.75.75 0 010 1.5"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u30D1\\u30B9 529",
    d: "M15.788 17.421a.749.749 0 01-.587-.282l-2.567-3.219a.75.75 0 111.173-.935l2.566 3.215a.75.75 0 01-.586 1.218"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u30D1\\u30B9 530",
    d: "M17.983 17.421a.75.75 0 01-.589-1.214l5.669-7.2a.75.75 0 111.179.928l-5.669 7.2a.75.75 0 01-.59.286"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u30D1\\u30B9 531",
    d: "M29.761 18.483a.75.75 0 01-.606-1.191l2.51-3.455a.75.75 0 111.214.882l-2.51 3.455a.749.749 0 01-.607.309"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u30D1\\u30B9 532",
    d: "M29.654 18.483a.749.749 0 01-.607-.309l-2.51-3.455a.75.75 0 111.214-.882l2.51 3.455a.75.75 0 01-.606 1.191"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u30D1\\u30B9 533",
    d: "M24.909 17.808a7.85 7.85 0 107.85 7.85 7.85 7.85 0 00-7.85-7.85m3.621 3.377l-2.915 3.4h1.438a.536.536 0 110 1.071h-1.608v1.071h1.607a.536.536 0 110 1.071h-1.607v2.679a.536.536 0 11-1.072 0V27.8h-1.607a.536.536 0 110-1.071h1.607v-1.072h-1.607a.536.536 0 110-1.071H24.2l-2.915-3.4a.535.535 0 01.812-.7l2.808 3.275 2.807-3.274a.535.535 0 11.813.7"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCostServiceConfIcon);
export default __webpack_public_path__ + "static/media/costServiceConfIcon.2d5f144673239cec.svg";
export { ForwardRef as ReactComponent };